import { useLang } from "@/i18n/LangContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Cookie, Shield, Globe, Mail } from "lucide-react";

export default function CookiePolicyPage() {
  const { t } = useLang();

  const sections = [
    {
      icon: Cookie,
      title: t("cookie_what_title"),
      text: t("cookie_what_text"),
    },
    {
      icon: Shield,
      title: t("cookie_types_title"),
      text: null,
      subsections: [
        {
          title: t("cookie_essential_title"),
          text: t("cookie_essential_text"),
          list: [
            t("cookie_list_auth"),
            t("cookie_list_lang"),
            t("cookie_list_cookie"),
            t("cookie_list_gdpr"),
          ],
        },
      ],
    },
    {
      icon: Globe,
      title: t("cookie_third_title"),
      text: t("cookie_third_text"),
    },
    {
      icon: Shield,
      title: t("cookie_rights_title"),
      text: t("cookie_rights_text"),
    },
    {
      icon: Mail,
      title: t("cookie_contact_title"),
      text: t("cookie_contact_text"),
    },
  ];

  return (
    <div className="min-h-screen bg-[#050505] text-white" data-testid="cookie-policy-page">
      <Navbar />
      <div className="max-w-3xl mx-auto px-6 py-24">
        <h1 className="text-3xl md:text-4xl font-bold mb-4" data-testid="cookie-policy-title">
          {t("cookie_policy_title")}
        </h1>
        <p className="text-sm text-neutral-400 mb-12">{t("cookie_policy_intro")}</p>

        <div className="space-y-10">
          {sections.map((section) => (
            <div key={section.title} className="glass-card p-6 rounded-xl" data-testid={`cookie-section-${section.title}`}>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-purple-500/10 rounded-lg">
                  <section.icon className="w-4 h-4 text-purple-400" />
                </div>
                <h2 className="text-lg font-semibold">{section.title}</h2>
              </div>
              {section.text && (
                <p className="text-sm text-neutral-400 leading-relaxed">{section.text}</p>
              )}
              {section.subsections?.map((sub) => (
                <div key={sub.title} className="mt-4">
                  <h3 className="text-sm font-semibold text-purple-300 mb-2">{sub.title}</h3>
                  <p className="text-sm text-neutral-400 leading-relaxed mb-3">{sub.text}</p>
                  {sub.list && (
                    <ul className="space-y-2 ml-4">
                      {sub.list.map((item) => (
                        <li key={item} className="text-sm text-neutral-500 flex items-start gap-2">
                          <span className="text-purple-500 mt-1">&#8226;</span>
                          {item}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>

        <p className="text-xs text-neutral-600 mt-8 text-center">{t("cookie_updated")}</p>
      </div>
      <Footer />
    </div>
  );
}
